var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQueryLeftLayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 579,
    viewBox: "0 0 545 579",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M367.531 82.5984L356.274 97.7713L306.281 165.181L245.032 82.5984H367.531Z",
    fill: "#00CC8F"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M545 147.676H448.473L448.466 147.669L496.726 82.5991H496.74L545 147.669V147.676Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.769 165.189L245.018 82.6064H245.032L306.281 165.189L306.274 165.196H183.775L183.769 165.189Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M367.515 81.7568L427.773 0.51635H307.261L367.515 81.7568Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2632 330.382L61.2563 330.375L122.506 247.793H122.519L183.769 330.375L183.762 330.382H61.2632Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 247.789L183.769 330.372L122.52 247.789H245.018Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.513 247.776L183.762 165.193H183.776L245.025 247.776L245.018 247.79H122.52L122.513 247.776Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.769 495.552L122.513 412.969H245.018L183.769 495.552Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M122.506 412.97H122.513L183.769 495.552L183.762 495.56H61.2563V495.552L122.506 412.97Z",
    fill: "white",
    fillOpacity: 0.3
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.513 578.143L61.2563 495.56H183.762L122.513 578.143Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.513 83.4365L62.2444 164.696H182.781L122.513 83.4365Z",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.506 247.784H0.00684357L0 247.777L61.2494 165.195H61.2631H183.762L122.513 247.777L122.506 247.784Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M182.769 330.882H61.5011L0.988048 412.472H122.256L182.769 330.882Z",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M306.267 0.0163527H306.274H306.267L245.025 82.5986L183.775 0.0163527H306.254H306.267Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 412.97H245.025L306.281 495.552L306.274 495.56H183.769V495.552L245.018 412.97Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M428.794 164.349L489.05 83.1057H368.538L385.044 105.371L385.044 105.371L428.794 164.349Z",
    stroke: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M384.241 105.965L367.618 83.543L367.61 83.5608L367.523 83.444L356.675 98.0744L306.905 165.185L367.538 246.936L428.171 165.185L384.241 105.965L384.606 105.694L384.241 105.965ZM366.529 82.1036L306.268 0.85347L246.013 82.1036H366.529ZM183.769 164.347L244.402 82.5954L183.524 0.514099H62.2565L122.77 82.1036H122.771L122.921 82.3057L183.769 164.347Z",
    stroke: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M306.281 166.024L246.008 247.29H366.555L306.281 166.024Z",
    stroke: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M183.762 165.196L183.769 165.189L183.775 165.196H183.762Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.363 343.478L352.652 370.832L372.946 343.478H332.363Z",
    stroke: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M236.624 513.585L269.052 557.307L301.481 513.585H236.624Z",
    stroke: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M306.281 495.56H306.274L306.281 495.554V495.56Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M490.05 82.6L490.057 82.6064H490.043L490.05 82.6Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M428.801 165.196H428.787L428.794 165.189L428.801 165.196Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M183.768 495.56H183.762L183.768 495.554V495.56Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M367.544 247.79H367.531L367.538 247.774L367.544 247.79Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M184.757 329.882H305.293L245.025 248.623L184.757 329.882Z",
    stroke: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M244.025 412.472L183.762 331.222L123.501 412.472H244.025Z",
    stroke: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 412.972L183.762 330.382H306.302L245.018 412.972Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M183.742 0.00916453H183.755L244.998 82.5772L244.991 82.5915L244.998 82.5986H122.499L122.492 82.5915L183.742 0.00916453Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M306.282 0.00916453H306.302L367.538 82.5772L367.531 82.5915L367.538 82.5986H245.046L245.039 82.5915L306.282 0.00916453Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 412.97L306.288 495.531L306.274 495.545L306.281 495.56H183.789L183.782 495.545L245.018 412.97Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M122.205 247.627H122.218L183.461 330.195L183.454 330.209L183.461 330.224H60.9619L60.9551 330.209L122.205 247.627Z",
    fill: "#00CC8F"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M428.766 165.202L417.509 180.375L367.517 247.784L306.268 165.202H428.766Z",
    fill: "#00CC8F"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M411.689 142.132L428.794 165.196H306.295L367.544 82.6135L411.689 142.132Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M325.132 339.502L288.362 289.927V289.92H288.369H361.902L325.132 339.502Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 82.6479L184.084 0.0942201H122.855V82.6479Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryLeftLayer);
export default __webpack_public_path__ + "static/media/queryLeftLayer.d913d55453081a237c67a1c374fea139.svg";
export { ForwardRef as ReactComponent };